import styled from '@emotion/styled'
import { PlusCircleFilled } from '@ant-design/icons'
import { Input } from 'antd'
import colors from '@sportninja/common/constants/appColors'
import { useState } from 'react'
import Text from 'src/components/ts-components/Text'
import { paragraphSmall } from 'src/components/css'

type Props = {
  label: string
  placeholder: string
  onCreate: (name: string) => void
}

const InlineCreateRow = ({ label, placeholder, onCreate }: Props) => {
  const [editing, setEditing] = useState(false)
  const [value, setValue] = useState('')

  const submit = () => {
    const trimmed = value.trim()
    if (!trimmed) {
      setEditing(false)
      return
    }
    onCreate(trimmed)
    setValue('')
    setEditing(false)
  }

  if (!editing) {
    return (
      <AddButton type='button' onClick={() => setEditing(true)}>
        <PlusCircleFilled />
        <Text variant='paragraphSmall' weight='medium' color={colors.PRIMARY}>
          {label}
        </Text>
      </AddButton>
    )
  }

  return (
    <StyledInput
      autoFocus
      placeholder={placeholder}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={submit}
      onPressEnter={submit}
      data-testid='inline-create-input'
    />
  )
}

export default InlineCreateRow

// ---- styled ----
const StyledInput = styled(Input)`
  &.ant-input,
  &.ant-input-affix-wrapper > input.ant-input {
    ${paragraphSmall};
    color: ${colors.WHITE};
  }
`

const AddButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px;
  border: 1px solid ${colors.SECONDARY_200};
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  color: ${colors.PRIMARY};
  &,
  & * {
    cursor: pointer;
  }
`
